import axios from 'axios';

/**
 * Global response interceptor on the DEFAULT axios instance.
 *
 * Many services call the backend with a raw `import axios from 'axios'` rather than the
 * intercepted AuthenticatedAxios client. Those calls would otherwise miss the 402
 * "out of AI tokens" signal and fail silently. This catches a 402 INSUFFICIENT_TOKENS
 * from ANY default-axios call and dispatches the same `insufficient-tokens` window event
 * that App's handler reacts to (open the purchase screen / inform the user).
 *
 * Imported once for side effect in index.js. AuthenticatedAxios (a separate axios.create
 * instance) has its own copy of this check, so no call double-fires the event.
 */
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const data = error?.response?.data || {};
    if (status === 402 && (data.code === 'INSUFFICIENT_TOKENS' || data.error === 'insufficient_tokens')) {
      window.dispatchEvent(new CustomEvent('insufficient-tokens', { detail: data }));
    }
    return Promise.reject(error);
  }
);
